module.exports = __webpack_public_path__ + "static/img/bg-pt.03ea0d91.png";